<template>
    <v-form
            ref="modifyBlockForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="">
            <div class="primary d-flex align-center">
                <div class="flex-grow-1 primary pl-3 pr-2 sub--text">
                    {{block.id ? 'Edit Block' : 'Create Block'}}
                </div>
                <div class="pr-1" v-if="!block.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
                <v-text-field
                        label="Block Name"
                        hide-details="auto"
                        v-model="block.description"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                        :error-messages="blockNameErrorMessages"
                />
                <v-autocomplete
                        label="Farm"
                        hide-details="auto"
                        no-data-text="No available farms"
                        v-model="block.fkFarm"
                        item-text="description"
                        item-value="id"
                        :items="farms"
                        @input="changesMade = true"
                        clearable
                        @click.clear="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                />
                <v-autocomplete
                        :disabled="!block.fkFarm"
                        label="Variety"
                        hide-details="auto"
                        no-data-text="No available farms"
                        v-model="block.fkVariety"
                        item-text="description"
                        item-value="id"
                        :items="selectedFarm.varieties"
                        @input="changesMade = true"
                        clearable
                        @click.clear="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                />
              <v-switch
                  @change="changesMade = true"
                  hide-details="auto"
                  label="Disable Block"
                  v-model="blockDisabled"
                  class="py-2 mt-2"
              ></v-switch>
            </div>
            <div class="text-right pr-2 pt-2 pb-2">
                <v-btn
                        @click="validateSave()"
                        fab
                        small
                        color="secondary"
                        :loading="loading"
                        :disabled="!changesMade || loading"
                >
                    <v-icon v-if="!loading">mdi-content-save</v-icon>
                </v-btn>
            </div>
        </div>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        editBlock: Object
    },
    data() {
        return {
            block: null,
            blockNameErrorMessages: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false
        }
    },
    watch: {
        editBlock: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                this.block = JSON.parse(JSON.stringify(val))
            }
        },
        "block.description"() {
            this.blockNameErrorMessages = null
        },
        "block.fkFarm"() {
            this.block.fkVariety = null
            this.blockNameErrorMessages = null
        }
    },
    methods: {
        validateSave() {
            if (this.blocks.filter(obj =>
                    obj.id !== this.block.id
                    && obj.fkFarm === this.block.fkFarm
                    && (obj.description || '').toLowerCase() === (this.block.description || '').toLowerCase()).length
            ) {
                this.blockNameErrorMessages = 'Block name already exists in farm'
                return false
            }

            if (!this.$refs.modifyBlockForm.validate())
                return false

            this.$emit('save', {block: this.block, ref: this})
        }
    },
    computed: {
        ...mapGetters(['blocks', 'farmsRef', 'farms']),
        selectedFarm() {
            if (!this.block.fkFarm)
                return null
            return this.farmsRef[this.block.fkFarm]
        },
      blockDisabled: {
            get() {
                return !!this.block.disabled
            },
            set(val) {
              this.$set(this.block, 'disabled', val ? 1 : 0)
            }
        }
    },
  
}
</script>

<style scoped>

</style>